import React, { useState } from "react";
import useMobile from "../../hooks/useMobile";
import useTab from "../../hooks/useTab";
import { customFiltersStyles } from "../../exports/customSelectStyles";
import Select from "react-select";
// import { locationData } from "../../exports/location";
import { useOption } from "../../context/OptionContext";

const CooperativeFilters = () => {
  const isMobile = useMobile();
  const { categories } = useOption();
  const isTab = useTab();
  const regYearOptions = [
    { value: "2026", label: "2026" },
    { value: "2025", label: "2025" },
    { value: "2024", label: "2024" },
  ];

  const genderOptions =
    categories
      ?.find((item) => item.name === "Gender")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];

  const [filters, setFilters] = useState({
    regYear: "",
    gender: "",
    municipality: "",
    ward: "",
  });

  // const municipalityOptions = locationData.flatMap((province: any) => {
  //   const districts = Array.isArray(province.districts)
  //     ? province.districts
  //     : Object.values(province.districts || {});

  //   return districts.flatMap((district: any) => {
  //     const municipalities = Array.isArray(district.municipalities)
  //       ? district.municipalities
  //       : Object.values(district.municipalities || {});

  //     return municipalities.map((municipality: any) => ({
  //       label: municipality.name,
  //       value: municipality.name,
  //       wards: municipality.wards,
  //     }));
  //   });
  // });
  // const selectedMunicipality: any = municipalityOptions.find(
  //   (municipality) => municipality.value === filters.municipality,
  // );
  // const wardOptions = (
  //   Array.isArray(selectedMunicipality?.wards)
  //     ? selectedMunicipality.wards
  //     : Object.values(selectedMunicipality?.wards || {})
  // ).map((ward: any) => ({
  //   label: ward.toString(),
  //   value: ward.toString(),
  // }));

  const municipalityOptions = categories
      ?.find((item) => item.name === "Municipality (Local Level)")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];

  const wardOptions = categories
      ?.find((item) => item.name === "Ward")
      ?.dropdowns?.filter((item) => item.status === "Active")
      ?.sort((a, b) => a.order - b.order)
      ?.map((item) => ({
        value: item.label,
        label: item.label,
      })) || [];

  const handleFilterChange = (name: string, value: string) => {
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    <div
      className={`py-2 mb-3 d-flex gap-2 flex-wrap ${isMobile || isTab ? "justify-content-end" : "justify-content-between"}`}
    >
      <div className="search">
        <input className="form-control" placeholder="Search Cooperative" />
      </div>

      <div
        className={`d-flex gap-2 justify-content-end flex-wrap ${isMobile || isTab ? "w-100" : ""}`}
      >
        <Select
          className={`filter-select`}
          styles={customFiltersStyles("50%")}
          options={regYearOptions}
          placeholder="FY Year"
          isClearable
          value={
            regYearOptions.find((option) => option.value === filters.regYear) ||
            null
          }
          onChange={(selected) =>
            handleFilterChange("regYear", selected?.value || "")
          }
          menuPortalTarget={document.body}
          menuPosition="fixed"
          // data-menu-width="350px"
        />

        <Select
          className={`filter-select`}
          styles={customFiltersStyles(isMobile ? "50%" : "10%")}
          options={municipalityOptions}
          placeholder="Municipality"
          isClearable
          value={
            municipalityOptions.find(
              (option) => option.value === filters.municipality,
            ) || null
          }
          onChange={(selected) =>
            handleFilterChange("municipality", selected?.value || "")
          }
          menuPortalTarget={document.body}
          menuPosition="fixed"
          data-menu-width="350px"
        />

        <Select
          className={`filter-select`}
          styles={customFiltersStyles("50%")}
          options={wardOptions}
          placeholder="Ward no."
          isClearable
          value={
            wardOptions.find((option: any) => option.value === filters.ward) ||
            null
          }
          onChange={(selected) =>
            handleFilterChange("ward", selected?.value || "")
          }
          // noOptionsMessage={() =>
          //   !filters.municipality ? "Select municipality" : "No options"
          // }
          menuPortalTarget={document.body}
          menuPosition="fixed"
          // data-menu-width="350px"
        />

        <Select
          className={`filter-select`}
          styles={customFiltersStyles("50%")}
          options={genderOptions}
          placeholder="Gender"
          isClearable
          value={
            genderOptions.find((option) => option.value === filters.gender) ||
            null
          }
          onChange={(selected) =>
            handleFilterChange("gender", selected?.value || "")
          }
          menuPortalTarget={document.body}
          menuPosition="fixed"
          // data-menu-width="350px"
        />
      </div>
    </div>
  );
};

export default CooperativeFilters;
